module.exports = __webpack_public_path__ + "img/reset.0e004593.svg";